module.exports = __webpack_public_path__ + "static/media/red-triangle-alert.20d9f7bd.svg";